module.exports = __webpack_public_path__ + "img/tvhelper_pic_01.8d5ad7ff.png";